import React from 'react';
import './PageHero.css';

const PageHero = ({ 
  title, 
  subtitle, 
  description, 
  image, 
  video,
  overlay = true,
  gradient = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  sectionId
}) => {
  return (
    <section id={sectionId} className={`page-hero ${video ? 'has-video' : ''}`}>
      {video && (
        <div className="hero-video-container">
          <video 
            className="hero-video" 
            autoPlay 
            muted 
            loop 
            playsInline
          >
            <source src={video} type="video/mp4" />
          </video>
          {overlay && <div className="video-overlay"></div>}
        </div>
      )}
      {!video && image && (
        <div 
          className="hero-image-container"
          style={{ backgroundImage: `url(${image})` }}
        >
          {overlay && <div className="image-overlay" style={{ background: gradient }}></div>}
        </div>
      )}
      {!video && !image && (
        <div className="hero-gradient" style={{ background: gradient }}></div>
      )}
      <div className="page-hero-content">
        <div className="container">
          <div className="hero-text-content">
            {subtitle && <p className="hero-subtitle">{subtitle}</p>}
            <h1 className="hero-title">{title}</h1>
            {description && <p className="hero-description">{description}</p>}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageHero;

